import { InventoryDocumentKind, SaleDocumentKind } from "@skylab-shared/dataModel";

export enum DocumentCommonErrorCodes {
    DOCUMENT_FOR_RELATED_INVENTORY_DOCUMENT_ALREADY_EXISISTS = 'DOCUMENT_FOR_RELATED_INVENTORY_DOCUMENT_ALREADY_EXISISTS',
    KSEF_DOCUMENT_DURING_PROCESSING_ERROR_MESSAGE = 'KSEF_DOCUMENT_DURING_PROCESSING',
    BASE_ADVANCE_HAS_NOT_KSEF_NUMBER_ERROR_MESSAGE = "BASE_ADVANCE_HAS_NOT_KSEF_NUMBER",
    INCOMPLETE_OTHER_SELLER_DATA_ERROR_MESSAGE = 'INCOMPLETE_OTHER_SELLER_DATA',
    KSEF_DOCUMENT_CANNOT_BE_PRINTED = "KSEF_DOCUMENT_CANNOT_BE_PRINTED",
    DocumentWithoutSignature = 'DocumentWithoutSignature',
    ORDER_EXTERNAL_ID_EXIST_IN_OTHER_DOCUMENT = 'ORDER_EXTERNAL_ID_EXIST_IN_OTHER_DOCUMENT'
}

export type DocumentWithoutSignatureError = {
    status: 409;
    data: {
        code: DocumentCommonErrorCodes.DocumentWithoutSignature,
        objectProperties: {documentKind: SaleDocumentKind | InventoryDocumentKind}[]
    }
};

export const isDocumentWithoutSignatureErrorObject = (error: any): error is DocumentWithoutSignatureError => {
    return error?.data?.code === DocumentCommonErrorCodes.DocumentWithoutSignature;
};

